// src/styles.js

const goldColor = '#c5a059';
const darkNavy = '#0f172a'; // Ավելի խորը սև/կապույտ

// 1. Full Screen Menu Style (Mobile Drawer)
export const fullScreenMenuStyle = (isOpen) => ({
  position: 'fixed',
  top: 0,
  left: isOpen ? 0 : '-100%',
  width: '100%',
  height: '100vh',
  background: darkNavy,
  zIndex: 1500,
  transition: 'left 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
  overflowY: 'auto',
  color: 'white',
  padding: '80px 25px 40px'
});

// 2. Close Button inside Menu
export const closeMenuBtnStyle = {
  position: 'absolute',
  top: '20px',
  right: '20px',
  background: 'rgba(197, 160, 89, 0.1)',
  border: `1px solid ${goldColor}`,
  color: goldColor,
  width: '45px',
  height: '45px',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '22px',
  cursor: 'pointer',
  zIndex: 1600,
  transition: '0.3s'
};

// 3. Menu Links Container
export const menuLinksListStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '15px',
  marginTop: '20px'
};

// 4. Main Menu Link
export const fullMenuLink = {
  color: 'white',
  fontSize: '20px',
  textDecoration: 'none',
  fontWeight: '600',
  borderBottom: '1px solid rgba(255,255,255,0.05)',
  padding: '12px 0',
  display: 'block',
  transition: '0.3s'
};

// 5. Sub-menu Link
export const subMenuLink = {
  color: '#94a3b8',
  textDecoration: 'none',
  padding: '10px 0',
  fontSize: '15px',
  display: 'block',
  borderLeft: `1px solid ${goldColor}`,
  paddingLeft: '15px',
  marginLeft: '5px'
};

// 6. Mobile Bottom Navigation Bar
export const mobileNavStyle = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  width: '100%',
  height: '70px',
  background: '#111827', // Dark Slate
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  zIndex: 2000,
  borderTopLeftRadius: '25px',
  borderTopRightRadius: '25px',
  boxShadow: '0 -10px 30px rgba(0,0,0,0.4)',
  borderTop: `1px solid rgba(197, 160, 89, 0.1)`
};

// 7. Individual Nav Item (Icon + Text)
export const navItemStyle = (active) => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  color: active ? goldColor : '#94a3b8',
  textDecoration: 'none',
  fontSize: '11px',
  background: 'none',
  border: 'none',
  gap: '6px',
  cursor: 'pointer',
  transition: '0.3s',
  fontWeight: active ? '700' : '500'
});

// 8. Floating Call Button (Gold Circle)
export const callButtonStyle = {
  width: '60px',
  height: '60px',
  // Ոսկեգույն գրադիենտ
  background: `linear-gradient(135deg, ${goldColor}, #b38f4d)`,
  color: 'white',
  borderRadius: '50%',
  border: `5px solid #111827`, // Համապատասխանեցված ներքևի բարին
  position: 'absolute',
  top: '-30px',
  fontSize: '22px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: `0 8px 20px rgba(197, 160, 89, 0.4)`,
  cursor: 'pointer',
  transition: '0.3s transform ease'
};

// 9. Centered Logo for Mobile
export const logoCenterMobile = {
  position: 'absolute',
  left: '50%',
  transform: 'translateX(-50%)',
  fontWeight: '800',
  letterSpacing: '1px'
};

// 10. Global Modal Overlay
export const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'rgba(15, 23, 42, 0.9)',
  zIndex: 9999,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backdropFilter: 'blur(8px)'
};

// 11. Modal Content Card
export const modalContentStyle = {
  background: 'white',
  padding: '40px 30px',
  borderRadius: '28px',
  width: '85%',
  maxWidth: '320px',
  textAlign: 'center',
  boxShadow: '0 25px 50px rgba(0,0,0,0.2)',
  border: `1px solid rgba(197, 160, 89, 0.1)`
};

// 12. Modal Links (WhatsApp / Phone)
export const modalLink = (bg) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '12px',
  padding: '16px',
  // Եթե փոխանցվող ֆոնը նարնջագույն է՝ դարձնում ենք ոսկեգույն
  background: bg === '#f97316' ? goldColor : bg,
  color: 'white',
  borderRadius: '14px',
  textDecoration: 'none',
  marginBottom: '12px',
  fontWeight: 'bold',
  fontSize: '15px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
});